import React from 'react';
import { TERM_LOAN_FORM_FIELDS } from 'constants';
import { Button, Card, Form, message } from 'antd';
import cx from "classnames";
import {
    fieldGenerator,
    getErrorOnField,
    getValidateStatus
} from "utilities/form";
import { CaseService } from '../../services';
const FormItem = Form.Item;

class WCTLBLFields extends React.Component {
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);

    handleFormSubmit = (e) => {
        e.preventDefault();
        let data = this.props.form.getFieldsValue();
        CaseService.updateTermLoanTenorROi(this.props.caseId, data)
        .then((resp) => {
            message.success("Updated Successfuly");
        })
        .catch(error => {
            console.error("Error :", error);
        });
    }

    render(){
        return(
<Card title="Term Loan Fields" >
            <Form
            onSubmit={this.handleFormSubmit}
            className={cx("form", "br-3")}
        >
            <div className={"d-flex flex-row align-items-end flex-wrap w-100"}>

            {TERM_LOAN_FORM_FIELDS.map((field, fieldName) =>
                this.fieldGenerator(
                    fieldName,
                    field,
                    this.getErrorOnField(fieldName)
                )()
            )
                .toList()
                .toJS()}
            <FormItem>
                <Button type="primary"
                    className={"g-recaptcha"}
                    block
                    htmlType="submit"
                    // loading={this.props.formSubmitting}
                >
                    Submit
                </Button>
            </FormItem>
        </div>
        </Form>
        </Card>
        )
    }
}

export default Form.create({
    mapPropsToFields: ({ values }) =>
        values &&
        values
            .toSeq()
            .toMap()
            .map((value, key) => {
                return Form.createFormField({
                    value
                });
            })
            .toJS()
})(WCTLBLFields);
